export function ServerException({
    errorCode,
    response,
    bookingState,
    errorFields,
    message,
    type,
    code,
}) {
    this.errorCode = errorCode;
    this.response = response;
    this.bookingState = bookingState;
    this.errorFields = errorFields;
    this.message = message;
    this.type = type;
    this.code = code;
}

export const BookingErrorCodes = {
    General: 'GENERAL',
    MaxAppointmentsReached: 'MAX_APPOINTMENTS_EXCEPTION',
    MaxVaccineAppointmentsReached: 'MAX_VACCINE_APPOINTMENTS_EXCEPTION',
    AlreadyRescheduledException: 'ALREADY_RESCHEDULED_EXCEPTION',
    TimeslotGoneException: 'TIMESLOT_GONE_EXCEPTION',
};

export const BookingFieldFailureCodes = {
    phoneNotVerified: 'PhoneIsVerifiedFailure',
};

export const GA_ACTIONS = {
    ClickInsuranceCarrierDropdown: 'Click Insurance Carrier Dropdown',
    ClickInsurancePlanDropdown: 'Click Insurance Plan Dropdown',
    PreloadInsuranceCarrier: 'Preload Insurance Carrier',
    PreloadInsurancePlan: 'Preload Insurance Plan',
};

export const INSURANCE_ID_TYPE = {
    CARRIER: 'Carrier',
    PLAN: 'Plan',
};
